import { useEffect, useMemo, useState } from 'react';
import { useLazyQuery, useQuery } from '@apollo/client';
import AI_LIST_PROMPTS_QUERY from '../queries/AI_LIST_PROMPTS_QUERY';
import { getFormattedDate } from '../../utils';

const useAIListPrompts = ( onlySaved ) => {
    const [ prompts, setPrompts ] = useState( [] );
    const [pageData, setPageData] = useState();
    const [query, { data, loading, error } ] = useLazyQuery( AI_LIST_PROMPTS_QUERY );

    useEffect( () => {
        if ( loading || error || !data?.prompts?.edges ) { return; }

        setPageData(data.prompts.pageInfo)
        
        try {
            const result = data.prompts.edges.map( i => { 
                return {
                    ...i, 
                    name: i.label || ( !i.isSaved ? 'Unsaved Prompt' : 'Unnamed Prompt' ),
                    key: i.id || '',
                    createdAt: getFormattedDate( i.createdAt ),
                    updatedAt: getFormattedDate( i.updatedAt )
                };
            } );

            setPrompts( onlySaved ? result.filter( i => i.isSaved ) : result ); 
        } catch ( error ) {
            console.error( 'Error parsing prompts', error ); 
            setPrompts( [] );
        }
    }, [ loading, error, onlySaved ] );
   
    return useMemo( () => {
        return {
            query,
            prompts,
            pageData,
            promptsError: error,
            promptsLoading: loading, 
        };
    }, [ prompts, error, loading ] );
};

export default useAIListPrompts;
